const root = 'MyStoreCard'
const moreMenu = `${root}-moreMenu`
const contentRoot = 'MyStoresCard'

export const TestId = {
  root,
  moreMenu,
  moreMenuEditStoreSettings: `${moreMenu}-editStoreSettings`,
  moreMenuOpenStore: `${moreMenu}-openStore`,
  moreMenuConnectStore: `${moreMenu}-connectStore`,
  moreMenuDisconnectStore: `${moreMenu}-disconnectStore`,
  moreMenuDeleteStore: `${moreMenu}-deleteStore`,
  premiumBadge: `${contentRoot}_premiumBadge`,
  storeName: `${contentRoot}_storeName`,
  connectedTo: `${contentRoot}_connectedTo`,
  connectLink: `${contentRoot}_connectLink`,
  newOrdersCountText: `${contentRoot}_newOrdersCountText`,
  productsLeftText: `${contentRoot}_productsLeftText`,
  productsLeftWarning: `${contentRoot}_productsLeftWarning`,
  selectButton: `${contentRoot}_selectButton`,
}
